module.exports = __webpack_public_path__ + "static/media/imac-iphone.dfd1bd23.svg";